import { makeStyles } from "@material-ui/core";

const ProductListStyle = makeStyles(theme => ({
    buttonAddNewLine: {
        color: '#2D72D2',
        padding: 0,
        fontSize: '15px',
        fontWeight: 700,
        fontFamily: 'Zen Kaku Gothic New'
    },

    tableList: {
        borderCollapse: 'separate',
        borderSpacing: 0
    },

    tableCellProductName: {
        padding: '12px 16px',
        fontWeight: 600,
        maxWidth: '300px',
        minWidth: '300px',
        color: '#5D636F',
        fontFamily: 'Zen Kaku Gothic New',
        "@media (max-width: 576px)": {
            minWidth: '100px'
        }
    },

    tableCellItemProduct: {
        maxWidth: '300px',
        "@media (max-width: 576px)": {
            maxWidth: '100px'
        }
    },

    tableCellStatusName: {
        padding: '12px 16px',
        fontWeight: 600,
        maxWidth: '95px',
        minWidth: '95px',
        color: '#5D636F',
        fontFamily: 'Zen Kaku Gothic New'
    },

    itemProduct: {
        height: '50px',
        boxShadow: '0px -1px 0px 0px #E3E5E8 inset',
    },

    tableCellActionItem: {
        display: 'flex',
        justifyContent: 'space-between',
    }
}));

export { ProductListStyle };